import React from 'react';
import styled from 'styled-components';

import {BOTTOM_FRAME} from 'App';
import {getTopFrame} from 'Design/Design';

import Rods from '../Rods';

const TopBar = styled.div`
  width: calc(100% + 4px);
  background-image: url('img/gateway/top.png');
  background-size: contain;
  display: flex;
  flex-shrink: 0;
`;

const BottomBar = styled.div`
  width: calc(100% + 4px);
  background-image: url('img/gateway/bottom.png');
  background-size: contain;
  display: flex;
  flex-shrink: 0;
`;

const Container = styled.div`
  width: 58%;
`;

const Body = ({ design, scale, projectType }) => (
  <Container>
    <TopBar style={{ height: `${getTopFrame(projectType) / scale}px` }} />
    <Rods design={design} scale={scale} projectType={projectType} />
    <BottomBar style={{ height: `${BOTTOM_FRAME / scale}px` }} />
  </Container>
);

export default Body;
